import React from 'react';
import { Link } from 'react-router-dom';

const Meme = () => {
    return (
        <main className="meme-page">
            <div className="container py-4 py-md-5">
                <p className="text-center mb-3">
                    <Link to="/" className="text-decoration-none small text-white-50">
                        ← Volver al inicio
                    </Link>
                </p>
                <div className="meme-page__frame mx-auto">
                    <img
                        src="/images/memendez.jpeg"
                        alt="Meme"
                        className="meme-page__img"
                        width={960}
                        height={960}
                        loading="eager"
                        decoding="async"
                    />
                </div>
            </div>
        </main>
    );
};

export default Meme;
